import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import CLogin from "./CLogin";
import CSignup from "./CSignUp";

const SignUpIndex = ({ modalList, setModalList }) => {
  const [activeTab, setActiveTab] = useState("loginPage");

  const [modalListSignup, setModalListSignUp] = useState(false);
  // const [modalList, setModalList] = useState(true);

  useEffect(() => {
    console.log("modalList", modalList);
    console.log("modalListSignup", modalListSignup);
  }, []); // Add closing parenthesis ')' here

  const TogListSignIn = () => {
    setModalList(!modalList);
  };

  const TogListRegister = () => {
    setModalListSignUp(!modalListSignup);
  };

  const handleclick = (tabname) => {
    setActiveTab(tabname);
    if (tabname === "loginPage") {
      console.log("insideee");
      setModalList(!modalList);
      setModalListSignUp(true);
    } else {
      console.log("else");
      setModalList(false);
      setModalListSignUp(!modalListSignup);
    } // Add missing semicolon ';' here
  };

  return (
    <div>
      <Helmet>
        <title>Login | Ziya Mangalsutra - Sign In to Your Account</title>
        <meta name="description" content="Sign in or create your Ziya Mangalsutra account to save your favourite mangalsutra designs to your wishlist and track your inquiries." />
        <meta name="keywords" content="ziya mangalsutra login, customer login, mangalsutra account, ziya sign in" />
        <link rel="canonical" href={`${process.env.REACT_APP_API_URL_ZIYA}/login-user`} />
      </Helmet>
      {(() => {
        switch (activeTab) {
          case "loginPage":
            return (
              <CLogin
                modalList={modalList}
                setModalList={setModalList}
                handleclick={handleclick}
                TogListSignIn={TogListSignIn}
              />
            );
          case "2":
            return (
              <CSignup
                modalListSignup={modalListSignup}
                setModalListSignUp={setModalListSignUp}
                handleclick={handleclick}
                TogListRegister={TogListRegister}
              />
            );

          default:
            return <CLogin handleclick={handleclick} />;
        }
      })()}
    </div>
  );
};

export default SignUpIndex;
